export default "__VITE_ASSET__Bzc6_dd5__"